import request from '@/utils/request'; // 获取区域管理分组列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/areaGroupOa/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/areaGroupOa/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/areaGroupOa/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/areaGroupOa/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/areaGroupOa/update',
    method: 'post',
    data: data
  });
}